module.exports = __webpack_public_path__ + "assets/img/title-9048d261.png";